<template>
  <el-dialog
    width="900px"
    custom-class="import-dialog"
    title="添加商品"
    :visible="visible"
    @close="close"
  >
    <div class="p20">
      <div class="table-panel flex flex-between">
        <div class="flex-1 text-right">
          <el-cascader
            v-model="searchCondition.wxshopCategoryId"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="categoryFunc"
            clearable
            placeholder="请选择类目"
          ></el-cascader>
          <el-input
            clearable
            style="width: 200px"
            v-model.trim="searchCondition.keyWords"
            placeholder="请输入货号/条码/商品名/品牌"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table
          stripe
          border
          ref="brandTable"
          :highlight-current-row="radio"
          @current-change="handleCurrentChange"
          @selection-change="handleSelectionChange"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column v-if="!radio" type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="specIdGroupName"
            label="规格"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="showPrice"
            label="零售价"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="stockNum"
            label="可售库存"
          ></el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="this.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="saveGoods"
          >确 定</el-button
        >
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
  },
  components: {},
  data() {
    return {
      goodsSnList:[],
      tHeader: [],
      tBody: [],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      checkedCurrentRow: {},
      batchCondition: {
        oldWord: "",
        newWord: "",
        wxshopCategoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {},
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      list: [],
      total: 0
    };
  },
  computed: mapGetters([
    "microShopGoodsList",
    "salesChannels",
    "allMicroShopGoodsList"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch("querySalesChannels");
    this.queryList();
  },
  methods: {
    
    saveGoods() {
      if (this.radio) {
        this.$emit("setLink", this.checkedCurrentRow);
      } else {
        this.$emit("saveGoods", this.checkedRow);
      }
    },
    handleSelectionChange(row) {
      this.checkedRow = row;
    },
    handleCurrentChange(row) {
      this.checkedCurrentRow = row;
    },
    close() {
      this.$emit("close");
    },
    submitRuleForm() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.wxshopCategoryId =
        batchCondition.wxshopCategoryId[
          batchCondition.wxshopCategoryId.length - 1
        ];
      batchCondition.spuIdList = this.checkedRow;
      this.$store.dispatch("batchEdit", batchCondition).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      });
    },
    addGoods() {
      this.$router.push({ name: "AddGoods" });
    },
    edit(row) {
      this.$router.push({
        name: "EditGoods",
        query: {
          spuId: row.spuId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryList(queryAll) {
      const { storeCode } = getLoginUser();
      console.log("storeCode:",storeCode);
      let result = "";
      const { goodsSnList } = this.$store.dispatch(
        "queryDailyNews",
        {
          shopId: "",
          storeCode
        }        
      ).then(res => { 
        if(res.code === "0") {
             result = res.result;
             console.log("result:",result);
             if(!result.length){
               this.list = [];
               this.$emit("dailyNewsList2", this.list);
               return false;
             }
             const params = {
              pageSize: queryAll ? 99999 : this.pageSize,
              pageNo: this.currentPage,
              salesState: "up",
              goodsSnList:result,
            };
        
            const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
            searchCondition.wxshopCategoryId = this.isArray(
              searchCondition.wxshopCategoryId
            )
              ? searchCondition.wxshopCategoryId[
                  searchCondition.wxshopCategoryId.length - 1
                ]
              : searchCondition.wxshopCategoryId;

            searchCondition.attributeId = this.isArray(searchCondition.attributeId)
              ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
              : "";
            Object.assign(params, searchCondition);
            const actionName = queryAll
              ? "queryAllMicroShopGoodsListNews"
              : "queryMicroShopGoodsListNews";
            
            console.log("actionName2:",actionName);
            this.$store.dispatch(actionName, params).then((result) => {
                console.log("result", result);
                this.list = result.result.records;
                this.total = result.result.total;
                this.$emit("dailyNewsList2", this.list);
                console.log("dailyNewsList2", this.list);
                console.log("this.total", this.total);
            })
          }
      });

    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
